<form [formGroup]="formGroup" class="tug">
  @if (pageTitle) {
    <div class="tug-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="tug-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "text") {
      <div class="tug-row">
        <div class="tug-q">
          <div class="tug-q-title">
            {{ getQuestionTitle(element.title) }}
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="tug-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div>
          <input
            type="text"
            class="tug-input"
            [attr.inputmode]="isTimeElement(element) ? 'decimal' : null"
            [formControlName]="element.name"
          />
          @if (isTimeElement(element) && isInvalid(element)) {
            <div class="tug-error">
              {{ "Enter a time above 0" | translate }}
            </div>
          }
          @if (isTimeElement(element) && isEditable(element)) {
            <div class="tug-hint">{{ "TUG_UnableHint" | translate }}</div>
          }
        </div>
      </div>
    }
  }
</form>
